/* eslint-disable @typescript-eslint/no-explicit-any */
import { Select as AntSelect, SelectProps, Checkbox } from 'antd'
import { BaseOptionType, DefaultOptionType, RefSelectProps } from 'antd/lib/select'
import React, { ForwardedRef, MouseEventHandler, useMemo, useState } from 'react'
import { Wrapper } from './styles'
import { CloseIcon } from '../../icons'
import { sentenceGenerationForMultiSelect } from 'src/utils/sentenceGeneration'

export interface ISelectProps extends SelectProps<any, BaseOptionType | DefaultOptionType> {
  placeholder?: string
  isMultiSelect?: boolean
}

const Select = React.forwardRef<RefSelectProps, ISelectProps>(
  (props: ISelectProps, ref: ForwardedRef<RefSelectProps>) => {
    const [selectedValues, setSelectedValues] = useState<string[]>(
      props.defaultValue?.map((value: any) => value.value) ?? [],
    )

    const handleChange = (option: any) => {
      if (selectedValues.includes(option.value)) {
        setSelectedValues(selectedValues.filter((v: any) => v !== option.value))
      } else {
        setSelectedValues([...selectedValues, option.value])
      }

      props.onChange && props.onChange(option.value, option)
      props.onSelect && props.onSelect(option.value, option)
    }

    const autoCompleteProps = useMemo(() => {
      const defaultAutoCompleteProps = {
        listHeight: 300,
        listItemHeight: 32,
        getPopupContainer: (triggerNode: any) => {
          return triggerNode.parentNode as HTMLElement
        },
        allowClear: { clearIcon: <CloseIcon /> },
      }

      const mergedProps = {
        ...defaultAutoCompleteProps,
        ...props,
      }
      delete mergedProps.isMultiSelect
      return mergedProps
    }, [props])

    const handleOnMouseDown: MouseEventHandler<HTMLDivElement> = (e) => {
      e.preventDefault()
      e.stopPropagation()
    }

    const onClear = () => {
      setSelectedValues([])
      props.onClear && props.onClear()
    }

    const generateLabel = () => {
      if (props.isMultiSelect && selectedValues.length > 0) {
        const array = selectedValues.map((value: string) => props.options?.find((item) => item.value === value)?.label)
        return sentenceGenerationForMultiSelect(array)
      } else {
        return undefined
      }
    }

    const customDropdown = () => {
      return (
        <div className="select-dropdown">
          {props.options?.map((option: any) => (
            <Checkbox
              key={option.value}
              value={option.value}
              checked={selectedValues.indexOf(option.value) !== -1}
              className={selectedValues.indexOf(option.value) !== -1 ? 'selected-item' : undefined}
              onChange={() => handleChange(option)}
            >
              {option.label}
            </Checkbox>
          ))}
        </div>
      )
    }

    return (
      <Wrapper id="nova-shared-Select-root">
        <AntSelect
          onMouseDown={handleOnMouseDown}
          {...autoCompleteProps}
          ref={ref}
          dropdownRender={props.isMultiSelect ? customDropdown : undefined}
          value={generateLabel()}
          placeholder={props.placeholder}
          virtual={false}
          onClear={onClear}
          style={{ minWidth: '150px' }}
        ></AntSelect>
      </Wrapper>
    )
  },
)

Select.displayName = 'Select'
export default Select
